// ════════════════════════════════════════════════════════════════════════════
//  boletosService.ts  —  Gestão de boletos (MovBoleto)
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  BoletoResumo,
  EmitirBoletoRequest,
  BaixarBoletoRequest,
  PaginadoResponse,
} from '../types';

export interface ListarBoletosParams {
  clienteId?:     number;
  isPago?:        boolean;
  dtInicio?:      string;
  dtFim?:         string;
  pagina?:        number;
  tamanhoPagina?: number;
  /** Sem valor o servidor ordena pelo vencimento, mais distante primeiro. */
  ordenarPor?:    OrdenarPorBoletos;
  decrescente?:   boolean;
}

export type OrdenarPorBoletos = 'vencimento' | 'valor' | 'baixa' | 'numero';

const BASE = '/api/boletos';

export const boletosService = {
  async listar(params: ListarBoletosParams = {}): Promise<PaginadoResponse<BoletoResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<BoletoResumo>>(BASE, { params });
    return data;
  },

  async obterPorId(id: number): Promise<BoletoResumo> {
    const { data } = await apiClient.get<BoletoResumo>(`${BASE}/${id}`);
    return data;
  },

  async emitir(req: EmitirBoletoRequest): Promise<BoletoResumo> {
    const { data } = await apiClient.post<BoletoResumo>(BASE, req);
    return data;
  },

  async baixar(id: number, req: BaixarBoletoRequest): Promise<BoletoResumo> {
    const { data } = await apiClient.put<BoletoResumo>(`${BASE}/${id}/baixar`, req);
    return data;
  },

  async cancelar(id: number): Promise<BoletoResumo> {
    const { data } = await apiClient.put<BoletoResumo>(`${BASE}/${id}/cancelar`);
    return data;
  },

  async marcarImpresso(id: number): Promise<BoletoResumo> {
    const { data } = await apiClient.put<BoletoResumo>(`${BASE}/${id}/imprimir`);
    return data;
  },
};
